import { sdk } from "@/lib/medusa/client";
import { Company, CompanyAddress, Employee } from "@/types";
import { useQuery } from "@tanstack/react-query";

export const companyDetailsQueryKey = (companyName: string, scope = "public") =>
  ["company-details", scope, companyName] as const;

export const useCompanyDetails = (companyName: string, scope = "public") => {
  return useQuery({
    queryKey: companyDetailsQueryKey(companyName, scope),
    queryFn: async () => {
      try {
        const res = (await sdk.client.fetch(`store/companies/getByName/${companyName}`)) as { data: Company };
        return res.data;
      } catch (error) {
        console.error("Error fetching company details:", error);
      }
    },
    enabled: !!companyName,
  });
};

export const companyEmployeesQueryKey = (companyId: string) => ["company-employees", companyId] as const;

export const useAllEmployees = (companyId: string) => {
  return useQuery({
    queryKey: companyEmployeesQueryKey(companyId),
    queryFn: async () => {
      try {
        const res = (await sdk.client.fetch(`store/companies/${companyId}/employees`)) as { employee: Employee[] };
        return res.employee;
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    },
    enabled: !!companyId,
  });
};

export const companyAddressesQueryKey = (companyId: string) => ["company-addresses", companyId] as const;

export const useCompanyAddresses = (companyId: string | null | undefined) => {
  return useQuery({
    queryKey: companyAddressesQueryKey(companyId || ""),
    queryFn: async () => {
      try {
        const res = (await sdk.client.fetch(`store/companies/${companyId}/addresses`)) as {
          company_addresses: CompanyAddress[];
        };
        return res.company_addresses;
      } catch (error) {
        console.error("Error fetching company addresses:", error);
        return [];
      }
    },
    enabled: !!companyId,
  });
};
